import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";

import { getUserEmail, logout } from "./auth";
import { colors } from "./theme";

// Shown when a user authenticates successfully (valid Cognito session) but
// hasn't been promoted into any data-access group yet. Friendly explainer
// rather than a raw 403, since these are real humans who just signed up
// and don't know what to do next.
export default function PendingApprovalView() {
  const email = getUserEmail();

  return (
    <Container sx={{ pt: 8 }}>
      <Paper elevation={1} sx={{ p: 4, maxWidth: 560, mx: "auto" }}>
        <Stack spacing={2}>
          <Typography variant="h5">Account pending approval</Typography>
          <Typography variant="body1" sx={{ color: colors.gray700 }}>
            {email ? <>Hi <strong>{email}</strong> — </> : "Hi — "}
            your account exists but is not yet authorized to access this
            dashboard.
          </Typography>
          <Typography variant="body2" sx={{ color: colors.gray500 }}>
            An administrator must promote your account before you can use the
            system. If this is urgent, contact your supervisor and ask them to
            approve <code>{email ?? "your account"}</code>.
          </Typography>
          <Box sx={{ pt: 1 }}>
            <Button variant="outlined" onClick={logout}>
              Sign out
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
}
